import React from 'react'
import {
  View, Image, StyleSheet, Text
} from '@react-pdf/renderer'
import Emoji from '@generators/pdfComponents/icons/congrats.png'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    textAlign: 'center',
  },
})

// Create Document Component
export const CongratulationsText = () => (
  <View style={styles.container}>
    <Image src={Emoji} style={{ width: 24, height: 24 }} />
    <Text style={{ fontSize: 12, marginTop: 8 }}>
      Parabéns pela participação nas ações de saúde preventiva! O departamento
      de Medicina Preventiva da Unimed Assis se coloca à sua disposição para
      esclarecer qualquer eventual dúvida sobre cuidados com a saúde.
    </Text>
  </View>
)
